import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { cx } from './cx.js';
/** The heading of every in-progress sign-in step: the hub's sign-in pages and DestinationGate. */
export function signingInTitle(product) {
    return `Signing you in to ${product}`;
}
/** How long a step message stays before the next one may replace it. */
export const SIGNING_IN_MIN_STEP_MS = 600;
/**
 * The label to show for a stream of step labels: a new label replaces the shown one only after the shown one
 * has been visible for minMs, so quick internal steps never flash past faster than a person can read them.
 * Only the latest pending label is kept (a step that was already superseded is never shown).
 */
export function useSteadyLabel(label, minMs = SIGNING_IN_MIN_STEP_MS) {
    const [shown, setShown] = useState(label);
    const shownSince = useRef(Date.now());
    useEffect(() => {
        if (label === shown)
            return;
        const wait = Math.max(0, minMs - (Date.now() - shownSince.current));
        const timer = setTimeout(() => {
            shownSince.current = Date.now();
            setShown(label);
        }, wait);
        return () => clearTimeout(timer);
    }, [label, shown, minMs]);
    return shown;
}
/**
 * The one screen a person sees while Trace signs them in: a fixed heading and a spinner, identical on every page
 * of one sign-in (the static index.html shell of @traceio-org/auth-ui/vite-shell renders the same markup), so
 * moving between pages never changes what is on screen. Screen readers get one stable status message.
 */
export function SigningIn({ title, headingRef, hideTitle = false, className }) {
    return (_jsxs("div", { className: cx('trace-auth-signing-in', className), children: [_jsx("div", { className: cx('trace-auth-header', hideTitle && 'trace-auth-visually-hidden'), children: _jsx("h1", { ref: headingRef, tabIndex: -1, className: "trace-auth-title", children: title }) }), _jsxs("div", { className: "trace-auth-loading", role: "status", "aria-live": "polite", "aria-busy": "true", children: [_jsx("span", { className: "trace-auth-spinner", "aria-hidden": "true" }), _jsx("span", { className: "trace-auth-visually-hidden", children: title })] })] }));
}
//# sourceMappingURL=SigningIn.js.map